import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'section-b',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './section-b.component.html',
  styleUrl: './section-b.component.css'
})
export class SectionBComponent implements OnInit, OnChanges {

  @Input() fullTeamAssessmentData: any;
  @Output() onSaveSection4 = new EventEmitter<any>();

  yesNo = EYesNo;
  sectionBForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "What, if anything, did the student communicate to others and when? *",
      formControlName: "student_communication_others",
    },
    {
      question: "What was the context or physical location of this communication? *",
      formControlName: "communication_context",
    },
    {
      question: "To whom and how did the student communicate his/her intentions? *",
      formControlName: "communication_intentions",
    },
  ]

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fullTeamAssessmentData'] && this.fullTeamAssessmentData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.fullTeamAssessmentData?.[question.formControlName] || '', Validators.required);
    });
    group['b_additional_info'] = new FormControl(String(this.fullTeamAssessmentData?.b_additional_info) || this.yesNo.No, Validators.required);

    this.sectionBForm = new FormGroup(group);
  }

  saveSectionB(): void {
    if (this.sectionBForm.valid) {
        this.onSaveSection4.emit(this.sectionBForm.value);
    }
  }

}
